export const FIND_SERVICE_HISTORY_FORM = 'findServiceHistory'
export const FIND_SERVICE_HISTORY_FORM_STATE_FIELD = 'state'
export const FIND_SERVICE_HISTORY_FORM_LICENSE_FIELD = 'licensePlate'
export const FIND_SERVICE_HISTORY_FORM_VIN_FIELD = 'VIN'
